import i18n from '../../../../../i18n';

export const determineTopologyToCloneModalTitle = (
  isConfigurationPage: boolean,
): string =>
  isConfigurationPage
    ? i18n.t('topologies.clone.headingForConfigurationPage')
    : i18n.t('topologies.clone.heading');
